module.exports = __webpack_public_path__ + "files/e41bb989b4fcc598a7d1ecca7b70d1b5.png";